<template>
  <div>
    <b-row class="mt-2">
      <b-col>
        <h1 class="text-uppercase font-weight-bold">Stock</h1>
      </b-col>
      <b-col
        ><b-nav pills align="right">
          <span v-for="product in products" :key="product.value">
            <b-nav-item :to="`/camara/stock/${product.value}`"> {{ product.text }}</b-nav-item>
          </span>
        </b-nav></b-col
      >
    </b-row>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: "StockMain",
  data() {
    return {
      products: []
    };
  },
  beforeMount() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          console.log(res);
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.products = products;
        })
        .catch((error) => console.log(errors));
    }
  }
};
</script>

<style></style>
